import Axios from 'axios'

const CreateLead = ({
  registrationNumber,
  phoneNo,
  sourceName = 'SEO_FASTAG',
  productKey = 'car',
  apiKey = 'f4imWcFNATEZ4F'
}) => {
  Axios.post(
    '/lead/v1/create',
    {
      phone: phoneNo,
      product: productKey,
      registration_number: registrationNumber || '',
      source: sourceName
    },
    {
      headers: {
        apiKey
      }
    }
  )
    .then(res => {
      console.info('Create Lead Response', res)
    })
    .catch(e => {
      console.error('Error in create lead', e)
    })
}

export default CreateLead
